// Types
import type { I_apiGetDeps, I_apiGetDeps_Return } from "./apiGetDeps.types";

// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";

/** Получить Бренды / Категории */
const apiGetDeps: I_apiGetDeps = async (token: string) => {
    const fetchData = await axios.post<I_apiGetDeps_Return>(
        I_AXIOS.STAGE_API_HOST + "/api/tin/v1/site/quest/calc/deps/?token=" + token,
        {
            token: token,
        },
    );
    return fetchData.data;
};

export default apiGetDeps;
